/**
 * Licensee Cashier Config
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var utils = require('utils');

    var cashierConfig = require('portlets/cashier/cashier.config');

    module.exports = function(aspect) {

        var result = {
            BankPayment: {
                redirect: false,
                withdraw: {
                    redirect: false
                }
            }
        };

        var applyAspect = function(method, methodType) {
            if (!result[method]) {
                return;
            }

            utils.deepExtend(result[method], result[method][methodType]);
            delete result[method][methodType];
        };

        // eslint-disable-next-line no-shadow
        var extractAspect = function(aspect) {
            var split = aspect.split('.'),
                method = split[0],
                methodType = split[1];

            if (!method && !methodType) {
                return;
            }

            if (!methodType) {
                result = result[method];
                return;
            }

            if (!method) {
                // eslint-disable-next-line no-shadow
                _.keys(result).forEach(function(method) {
                    applyAspect(method, methodType);
                });
                return;
            }

            applyAspect(method, methodType);
            result = result[method];
        };

        if (aspect) {
            return extractAspect(aspect) || cashierConfig(aspect);
        }
        return _.extend({},cashierConfig(aspect), result);
    };

});
